import * as am4core from "@amcharts/amcharts4/core";
import { PACIFIC_BLU, HARVARD_CRIMSON } from "constants/colors";

export const COLORS1 = [
  am4core.color(PACIFIC_BLU),
  am4core.color(HARVARD_CRIMSON),
];
